<div class="roles">
  <ui-page-header [title]="'settings.roles_permissions' | translate" [lucideIcon]="'Shield'">
    <ui-button
      type="primary"
      [label]="('settings.role' | translate | uppercase)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="editRole()"></ui-button>
  </ui-page-header>

  <div class="roles__card">
    <div class="roles__table-wrapper">
      <table class="roles__table">
        <thead>
          <tr>
            <th>
              <button class="roles__sort-button" (click)="onSort('name')" type="button">
                <span>{{ 'settings.role_name' | translate }}</span>
                <span class="roles__sort-arrows">
                  <span class="roles__sort-arrow roles__sort-arrow--up" [class.roles__sort-arrow--active]="sortField === 'name' && sortMode === 'asc'"></span>
                  <span class="roles__sort-arrow roles__sort-arrow--down" [class.roles__sort-arrow--active]="sortField === 'name' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="roles__sort-button" (click)="onSort('type')" type="button">
                <span>{{ 'common.type' | translate }}</span>
                <span class="roles__sort-arrows">
                  <span class="roles__sort-arrow roles__sort-arrow--up" [class.roles__sort-arrow--active]="sortField === 'type' && sortMode === 'asc'"></span>
                  <span class="roles__sort-arrow roles__sort-arrow--down" [class.roles__sort-arrow--active]="sortField === 'type' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="roles__sort-button" (click)="onSort('features')" type="button">
                <span>{{ 'settings.features' | translate }}</span>
                <span class="roles__sort-arrows">
                  <span class="roles__sort-arrow roles__sort-arrow--up" [class.roles__sort-arrow--active]="sortField === 'features' && sortMode === 'asc'"></span>
                  <span class="roles__sort-arrow roles__sort-arrow--down" [class.roles__sort-arrow--active]="sortField === 'features' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="roles__sort-button" (click)="onSort('default_scope')" type="button">
                <span>{{ 'settings.default_scope' | translate }}</span>
                <span class="roles__sort-arrows">
                  <span class="roles__sort-arrow roles__sort-arrow--up" [class.roles__sort-arrow--active]="sortField === 'default_scope' && sortMode === 'asc'"></span>
                  <span class="roles__sort-arrow roles__sort-arrow--down" [class.roles__sort-arrow--active]="sortField === 'default_scope' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="roles__sort-button" (click)="onSort('users')" type="button">
                <span>{{ 'settings.assigned_users' | translate }}</span>
                <span class="roles__sort-arrows">
                  <span class="roles__sort-arrow roles__sort-arrow--up" [class.roles__sort-arrow--active]="sortField === 'users' && sortMode === 'asc'"></span>
                  <span class="roles__sort-arrow roles__sort-arrow--down" [class.roles__sort-arrow--active]="sortField === 'users' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let role of sortedRoles$ | async; trackBy: trackByRoleId">
            <tr (click)="openRoleDetails(role)">
              <td>
                <div class="roles__role-cell">
                  <span class="roles__role-name">{{ role.name }}</span>
                </div>
              </td>
              <td>
                <span class="roles__type-badge" [class.roles__type-badge--protected]="role.is_protected">
                  {{ role.is_protected ? ('settings.system_role' | translate) : ('settings.custom_role' | translate) }}
                </span>
              </td>
              <td>
                <span class="roles__metric">
                  <span class="roles__metric-actual">{{ getRoleModulesActualCount(role) }}</span>
                  <span class="roles__metric-total">/{{ getTotalModulesCount() }}</span>
                </span>
              </td>
              <td>
                <span class="roles__scope-badge" [class.roles__scope-badge--own]="getDataScope(role) === 'own'">{{ ('common.' + getDataScope(role)) | translate }}</span>
              </td>
              <td>
                <div class="roles__users">
                  <div class="roles__users-avatars" *ngIf="getUsersCount(role)">
                    <div class="roles__users-avatar" *ngFor="let user of role.users | slice:0:4">
                      <span
                        class="roles__users-avatar-initials"
                        [style.background]="getUserColor(getAssignedUserAvatarModel(user.name))"
                        [matTooltip]="user.name || ('user.user' | translate)"
                      >
                        {{ getUserInitials(getAssignedUserAvatarModel(user.name)) }}
                      </span>
                    </div>
                  </div>
                  <span class="roles__users-count">
                    {{ getUsersCount(role) }} {{ 'settings.users' | translate | lowercase }}
                  </span>
                </div>
              </td>
              <td class="roles__actions-cell" (click)="$event.stopPropagation()">
                <div class="roles__actions">
                  <button
                    *ngIf="!role.is_protected"
                    mat-icon-button
                    [matMenuTriggerFor]="roleMenu"
                    class="roles__actions-btn"
                    [attr.aria-label]="'common.actions' | translate"
                  >
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  <mat-menu #roleMenu="matMenu" xPosition="before" panelClass="ui-action-menu">
                    <button mat-menu-item class="ui-action-menu-item" (click)="editRole(role)">
                      <span class="ui-action-menu-item__icon">
                        <ui-svg-icon svgIcon="pen-cc"></ui-svg-icon>
                      </span>
                      <span class="ui-action-menu-item__label">{{ 'common.edit' | translate }}</span>
                    </button>
                    <button
                      mat-menu-item
                      class="ui-action-menu-item ui-action-menu-item--danger"
                      [disabled]="role.is_protected"
                      (click)="deleteRole(role)">
                      <span class="ui-action-menu-item__icon">
                        <ui-svg-icon svgIcon="trash-cc"></ui-svg-icon>
                      </span>
                      <span class="ui-action-menu-item__label">{{ 'common.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
